export default __webpack_public_path__ + "assets/front/scss/formulaire.d765ef168a77a517a3b45479b131f29c.css";